import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useGalleryViewStyles = makeStyles((theme: Theme) =>
  createStyles({
    '@global': {
      '.top-menu': {
        display: 'none',
      },
      footer: {
        display: 'none',
      },
      '.account-header': {
        display: 'none',
      },
    },
    editor: {},
    topBar: {
      zIndex: 2,
      width: '100%',
      position: 'fixed',
      top: 0,
      padding: 20,
      display: 'flex',
      flexDirection: 'row',
    },
    bottomBar: {
      zIndex: 10,
      position: 'fixed',
      bottom: -163,
      width: '100%',
      textAlign: 'center',
      transition: 'transform 330ms ease-in-out',
    },
    fadeOut: {
      opacity: 0,
      transition: 'opacity 330ms ease-in-out',
    },
    moveDown: {
      transform: 'translateY(36px)',
    },
    moveUp: {
      transform: 'translateY(-163px)',
    },
    folded: {
      transform: 'translateY(0)',
    },
    hidePanoramasButton: {
      cursor: 'pointer',
      background: theme.palette.primary.main,
      transition: 'background 100ms ease-in-out',
      width: 75,
      borderRadius: 15,
      height: 5,
      margin: 10,
      '&:hover': {
        background: '#FF964D',
      },
    },
    fullScreenToggle: {
      position: 'fixed',
      bottom: '60px',
      right: 30,
      cursor: 'pointer',
    },
    previous: {
      zIndex: 2,
      position: 'fixed',
      top: 'calc((100% - 200px) / 2)',
      textAlign: 'center',
      left: 10,
      '& svg': {
        fontSize: 40,
        fill: theme.palette.primary.main,
      },
      color: 'white',
    },
    next: {
      zIndex: 2,
      position: 'fixed',
      top: 'calc((100% - 200px) / 2)',
      right: 10,
      textAlign: 'center',
      '& svg': {
        fontSize: 40,
        fill: theme.palette.primary.main,
      },
      color: 'white',
    },
    panorama: {
      height: '100vh',
      width: '100%',
      backgroundColor: '#0000',
      overflow: 'hidden',
      '& canvas': {
        width: '100%',
        height: '100%',
        border: 'none',
      },
    },
    error: {
      padding: 24,
    },
    saveAs: {
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#FF964D',
        boxShadow: 'none',
      },
    },
  }),
);
